import {Stack, Typography} from "@mui/material";
// import {isEmpty} from "../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function AdmsIdentifierDisplay(props) {
  const [mappings, setMappings] = useState(props.mappings);
  const {defaultLanguage, admsIdentifierList} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }

  if (!admsIdentifierList || admsIdentifierList.length === 0) return null;

  return (
    <div>
      <Typography variant="h5" noWrap sx={{pt: 1, fontWeight: "600"}}>{getLabel(keys.admsIdentifier, "admsIdentifier")}</Typography>

      {admsIdentifierList.map((item, index) => {
        return (
          <Stack key={index} sx={{pt: 1}} spacing={1}>
            {item.notation.getValue() && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.notation, "notation")}
                </Typography>
                {item.notation.getValue().includes("http") ? <a href={item.notation.getValue()} target="_blank" rel="noopener noreferrer" className="info_url">{item.notation.getValue()}</a> : item.notation.getValue()}
              </div>
            )}
            {item.schemaAgency.getValue(defaultLanguage) && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.schemaAgency, "schemaAgency")}
                </Typography>
                <Typography variant="body1">{item.schemaAgency.getValue(defaultLanguage)}</Typography>
              </div>
            )}

          </Stack>
        );
      })}
    </div>
  );
}
